__turbopack_context__.v({
  "sliderBtn": "PlasmicSliderBtn-module__Ohu96G__sliderBtn",
  "sliderBtninactive": "PlasmicSliderBtn-module__Ohu96G__sliderBtninactive",
});
